import React from "react";

const TextInput = ({ placeHolder, type, nameOfInput, size, label }) => {
  return (
    <div className={size}>
      <label className="block font-medium text-white mb-2 text-sm ">
        {label}
      </label>
      <input
        className="block bg-grey p-2.5 w-full text-sm text-black shadow-sm focus:ring-primary-500 focus:border-primary-500 "
        type={type}
        name={nameOfInput}
        placeholder={placeHolder}
      />
    </div>
  );
};

export default TextInput;
